// import Language from '@components/language';
import './index.scss';
// import { isMobile } from 'react-device-detect'
// import ModalRenderContainer from '@components/modal/modal-render-container';
import PageTransition from '../../components/page-transition';

const Auth = ({ children }) => {
    return (
        <div className="auth-container">
            {/* <Language darkMode={true} /> */}
            {/* <div className={`form-modal${isMobile ? "-mobil" : ""}`}> */}
            <div className='form-modal'>
                <PageTransition>
                    {children}
                </PageTransition>
                {/* <ModalRenderContainer /> */}
            </div>
        </div>
    );
};
export default Auth;